import "./chatbot.css";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contextApi/ContextApi";
import { media } from "../../dataSets/media";
import ReactMarkdown from "react-markdown";

export default function Chatbot({ website, isDashboard}) {
    const { setToastMessage, primary_color, secondary_color, accent_color} = useContext(AppContext);
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [messages, setMessages] = useState([{role:"assistant",content:"היי! איך אני יכול לעזור לך היום?"}]);
    const [input, setInput] = useState("");
    const [loading, setLoading] = useState(false);
    const [typeText, setTypeText] = useState("Typing");

    useEffect(() => {
        if(!loading)return;
        let dots = 1;

        const timer = setInterval(() => {
        dots = dots === 3 ? 1 : dots + 1;
        setTypeText(`Typing${".".repeat(dots)}`);
        }, 400);

        return () => clearInterval(timer);
    }, [loading]);

    const sendMessage = async () => {
        if (!input.trim()) return;
        try {
            const newMessages = [
                ...messages,
                { role: "user", content: input }
            ];
        
            setMessages(newMessages);
            setInput("");
            setLoading(true);

            const emailText = "mailto:webingo.company@gmail.com";
            const phoneText = "https://wa.me/972507170101?text=היי%2C%20הגעתי%20דרך%20webingo%2C%20אשמח%20לעזרתכם";
            const websiteContext = isDashboard ? {
                support:{
                    instructions:`
                        You MUST respond ONLY with this text:
                        1. ${emailText}
                        2. ${phoneText}
                        Do NOT add anything else.
                    `,
                },
                instructions:{
                    addSocial:"על מנת להגדיר את הרשתות החברתיות ניתן לעשות זאת דרך כרטיסיית ניהול כללי > רשתות חברתיות, על יד כל אחת מהרשתות יש סימן שאלה שמסביר כיצד נראה לינק בהתאמה לרשת הרצויה",
                    changeTheme:"על מנת לשנות את צבעי הנושא של האתר ניתן לעשות זאת דרך כרטיסיית ניהול כללי > שינוי צבעי נושא, שם ניתן להגדיר את הצבעים הרצויים באופן חופשי",
                    addProduct:"בכדי להוסיף מוצר חדש ניתן לעשות זאת דרך כרטיסיית ניהול תוכן האתר > המוצרים שלי, עליך לוודא שקיימת קטגוריה אחת לפחות, שם מוסבר אילו נתונים המוצר דורש, במידה ולא תוסיף תמונה למוצר הוא ייקבל את התמונה לוגו האתר",
                    addJob:"ניהול תוכן האתר>דרושים",
                    addBranch:"ניהול תוכן האתר>הסניפים שלי",
                    setAbout:"ניהול תוכן האתר>אודות - הוספת מקטע>כותרת ותוכן",
                    changeProductData:"לאחר שהוספת מוצר חדש בכרטיסיית ניהול תוכן האתר > המוצרים שלי, תופיע רשימת מוצרים, לחיצה על כל מוצר תעביר אותך לעמוד עדכון המוצר",
                    addCategory:"בכרטיסיית ניהול תוכן האתר > המוצרים שלי, ניתן להוסיף קטגוריה חדשה/ לשנות את שם הקטגוריה הקיימת, במידה ולא התווספה תמונה לקטגוריה - הקטגוריה תקבל את תמונת לוגו האתר",
                    specificProductData:"בכל בקשה למידע על מוצר מסויים - תפנה את הלקוח לכרטיסיית ניהול תוכן האתר > המוצרים שלי",
                    specificCategoryData:"בכל בקשה למידע על קטגוריה מסויימת - תפנה את הלקוח לכרטיסיית ניהול תוכן האתר > המוצרים שלי",
                },
                name: website.settings?.website_name,
                subject:website.settings?.subject,
                social:["facebook","instagram","whatsapp"],
                productsLength:website.settings?.categories?.flatMap(cat=>cat?.products).length,
                categoriesNames:website.settings?.categories?.flatMap(cat=>cat?.name),
                theme: website.settings?.theme, 
            } : {
                support:{
                    instructions:`
                        You MUST respond ONLY with this text:
                        1. ${emailText}
                        2. ${phoneText}
                        Do NOT add anything else.
                    `,
                },
                instructions:{
                    basic:"ליד כל שלב יש '?' אשר נותן הסבר על השלב והוראות ראשוניות, נסה להפנות את הלקוח להסבר זה במידה וקיים.",
                    userCreationProcess:"שלב זה יוצר את פרטי ההתחברות למערכת הניהול, הסבר את החשיבות לזכור סיסמא ומייל לצורך התחברות לניהול האתר",
                    websiteCreationProcess:{
                        basic:"הסבר ללקוח על חשיבות שלב זה, כאן הלקוח יוצר את פרטי האתר הראשוניים אשר יאפיינו את האתר שלו, רובם יהיו ניתנים לשינוי בהמשך",
                        domain:"הדומיין חייב להיות זמין ובעל סיומת כלשהי מתוך האפשרויות הנתונות, ניתן לראות את האפשרויות ב'?' שליד שלב זה, דומיין לא ניתן לשינוי לאחר ביצוע התשלום."
                    },
                    paymentProcess:"בעמוד זה מתבצע התשלום - על הלקוח לדעת כי פרטי התשלום שלו אינם נשמרים.",
                },
                name: "Webingo",
                subject:"Web creation platform"
            };
        
            const res = await fetch(
              `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECTID}.cloudfunctions.net/chatbot`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ isDashboard, websiteId: website?.id, websiteContext, messages: newMessages }),
              }
            );
            
            const data = await res.json();
            if(data?.reply?.includes("mailto")){
                setMessages([
                    ...newMessages,
                    { role: "support", content: {emailText, phoneText} }
                ]);
                return;
            }
        
            setMessages([
                ...newMessages,
                { role: "assistant", content: data.reply }
            ]);
        
        } catch (error) {
            console.error("Error on chatbot: ",error)
            setToastMessage("מתנצלים קרתה תקלה, מומלץ לרענן את הדף");
        } finally{
            setLoading(false);
        }

    };

    return isChatOpen ? (
        <div dir="ltr" className={"chatbot_open"} style={{"--accent-color":isDashboard ? accent_color : "rgba(30, 70, 130, 0.7)", "--secondary-color":isDashboard ? secondary_color : "rgba(30, 70, 130, 0.3)", border:`0.5px solid ${isDashboard ?  accent_color : "rgba(30, 70, 130, 0.7)"}`, backgroundColor:isDashboard ? primary_color : "white"}}>
            <div className="chatbot_xBtn" style={{color:isDashboard ? accent_color : "rgba(30, 70, 130, 0.7)", textShadow:`2px 2px 3px ${secondary_color}`}} onClick={()=>{setIsChatOpen(false)}}>X</div>
            <div className="chatbot_messagesDiv">
                {messages
                .filter(m => m.role !== "system")
                .map((m, i) => (
                    <div className="chatbot_message"  key={`chatbot_msg_${i}`}>
                        <img src={m.role==="assistant"||m.role==="support"?media.chatbotAvater:media.def_logo} alt="chatbot_avatar" style={{width:30, height:30, borderRadius:"50%"}}/>

                        <div className="chatbot_message_bubble" style={{
                            backgroundColor:
                                isDashboard&&m.role==="assistant" ? accent_color:
                                isDashboard&&m.role==="support" ? accent_color:
                                isDashboard&&m.role==="user" ? secondary_color :
                                !isDashboard&&m.role==="assistant" ? "rgba(30, 70, 130, 0.7)":
                                "whitesmoke",
                            color:
                                isDashboard&&m.role==="assistant" ? secondary_color:
                                isDashboard&&m.role==="support" ? secondary_color:
                                isDashboard&&m.role==="user" ? accent_color:
                                !isDashboard&&m.role==="assistant" ? "whitesmoke":
                                "rgba(30, 70, 130, 0.7)",
                            border:"0.5px solid black",
                            textShadow:`1px 1px 3px ${isDashboard?primary_color:"black"}`}} dir="rtl">
                            {m.role==="support" ? <div>
                                <p>ניתן ליצור איתנו קשר במייל או בוואצאפ:</p>
                                <ol>
                                    <li>
                                        Email
                                        <a style={{textDecoration:"none", color:secondary_color, marginRight:"5px"}} href={m.content.emailText} target="_blank">
                                            <img style={{width:"30px", height:"30px", borderRadius:"50%", backgroundColor:"white", padding:"2px"}} src={media.gmailLogo} alt="gmail_logo"/>
                                        </a>
                                    </li>
                                    <li>
                                        Whatsapp
                                        <a style={{textDecoration:"none", color:secondary_color, marginRight:"5px"}} href={m.content.phoneText} target="_blank">
                                            <img style={{width:"30px", height:"30px", borderRadius:"50%", backgroundColor:"white", padding:"2px"}} src={media.whatsappLogo} alt="whatsapp_logo"/>
                                        </a>
                                    </li>
                                </ol>
                                <p>לכל שאלה נוספת אשמח לעזור!</p>
                            </div> : <ReactMarkdown>{m.content}</ReactMarkdown>}
                        </div>
                    </div>
                ))}
            </div>
            
            <div className="chatbot_inputContainer" style={{borderTop:`0.5px solid ${accent_color}`}}>
                {loading && <p className="chatbot_typing" style={{color:accent_color, textShadow:`2px 2px 3px ${secondary_color}`}}>{typeText}</p>}
                <input
                    onKeyDown={(e)=>{if(e.key === "Enter" && input !== ""){sendMessage()}}}
                    dir="rtl"
                    className="chatbot_input"
                    value={input}
                    onChange={e => setInput(e.target.value)}
                    placeholder="במה אוכל לעזור..."
                />
                <button className="chatbot_sendBtn" style={{color:!loading ? `${isDashboard?accent_color:"rgba(30, 70, 130, 0.7)"}` : "grey"}} onClick={sendMessage} disabled={loading}>
                    ➤
                </button>
            </div>
        </div>
    ) : (
        <div className={"chatbot_closed"} onClick={()=>{setIsChatOpen(true)}}>
            <img src={media.chatbotAvater} alt="chatbot_avatar_img" />
        </div>
    );
}
